export const STORE_NAME = 'HeyLibby'
export const SESSION_STORE_NAME = 'HeyLibbySession'
export const LOCAL_ENV = 'local'
export const DEVELOPMENT_ENV = 'development'
export const PRODUCTION_ENV = 'production'
export const STAGING_ENV = 'staging'
export const HEY_LIBBY_SITES = [
  'localhost',
  'heylibby.ai',
  'heylibby.co',
  'heylibby.net',
  'main.d3tfrvso00g6f0.amplifyapp.com',
  'staging.mylibby.ai',
  'develop.d1yqa48wwh6uoh.amplifyapp.com',
]
export const API_NAME = 'heylibbyapi'
export const API_REGEX_PATH = /(?!\/):(\w+)(?=\/?)/g
export const ENTER_KEY = 'Enter'
export const NEW_LINE = '\n'
export const URL_REGEX = /^(?!https?:\/\/)/i
export const EMAIL_REGEX =
  /^[a-zA-Z0-9.!#$%&*+=^_`{|}~-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/
export const ALPHA_NUMERIC_NO_SPACE_REGEX = /^[a-zA-Z0-9]+$/
export const SMALL_CASE_LETTERS_NUMBERS_REGEX = /[^a-zA-Z0-9]/g
export const VALID_EMAIL_CHARACTERS = /^[a-zA-Z0-9.!#$%&*+=^_`{|}~-]+$/
export const MAX_UPLOAD_FILE_SIZE = 5e6
export const ONE_SECOND_IN_MS = 1_000
export const FIVE_MINUTES_IN_MS = 5 * 60 * ONE_SECOND_IN_MS
export const THIRTY_MINUTES_IN_MS = 30 * 60 * ONE_SECOND_IN_MS
export const TEN_SECONDS_IN_MS = 10 * ONE_SECOND_IN_MS
export const COMPLETE_URL_REGEX =
  /\bhttps?:\/\/[^\s/$.?#].[^\s]*\b|www\.[^\s/$.?#].[^\s]*\b/gi
export const ALLOWED_FILE_EXTENSIONS = [
  'png',
  'webp',
  'gif',
  'jpg',
  'jpeg',
  'bmp',
]
export const BREAK_TAG_REGEX = /<br\s*\/?>/gi
export const LINK_TAG_REGEX = /<a\s+href="([^"]*)">(.*?)<\/a>/gi
export const MONTH_DAY_YEAR_FORMAT = 'MM-DD-YYYY'
export const MONTH_DAY_YEAR_SLASH_FORMAT = 'MM/DD/YYYY'
export const MONTH_DAY_YEAR_TIME_SLASH_FORMAT = 'MM/DD/YYYY hh:mm A'
export const THREE_DIGITS_REGEX = /^\d{3}$/
export const AMERICAN_PHONE_PREFIX = '+1'
export const REMOVE_SYMBOLS_REGEX = /(?!^\+)[^0-9]/g
export const APPLY_FOR_REFERRAL_LINK =
  'https://share.hsforms.com/1ayRWkhziTMeDDrvXVkH3Cgqt2u3'
export const HEX_COLOR_REGEX = /^#[0-9A-F]{6}$/i
export const DELETE_USER_CONFIRMATION_KEY = 'delete'

export const ZAPIER_LINK = 'https://zapier.com'
export const TRANSPARENT_IMAGE =
  'data:image/gif;base64,R0lGODlhAQABAIAAAAAAAP///yH5BAEAAAAALAAAAAABAAEAAAIBRAA7'
export const OUTBOUND_CALLING_API_DOCUMENTATION =
  'https://heylibby.notion.site/Outbound-Phone-Calling-API-1a7d5d8d066645d5bd046cc23ddf1d18?pvs=4'
export const CALENDLY_WHITELABEL_LINK =
  'https://calendly.com/heylibby/discuss-heylibby-white-label'
export const DEFAULT_STALE_TIME = 10 * ONE_SECOND_IN_MS
export const CALENDLY_SCHEDULE_MEETING_LINK =
  'https://calendly.com/heylibby/meeting-with-heylibby'
export const HUBSPOT_TCR_FORM_SRC =
  'https://js-na2.hsforms.net/forms/embed/developer/45026715.js'
export const HUBSPOT_PORTAL_ID = '45026715'
export const HUBSPOT_TCR_FORM_ID = '98aad9d7-e463-48f5-a63f-88d4d216a0f8'
